export default __webpack_public_path__ + "static/media/nap1.3c8495d4.png";